import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

export const getListAreaUsage = async (searchValue) => {
  const api = `${APIEndpoint.GET_LIST_AREAUSAGE}`;

  const res = await axiosInstance.get(api);
  return res;
};

export const getListAreaUsageById = async (id) => {
  const api = `${APIEndpoint.GET_LIST_AREAUSAGE_ฺBY_ID}` + `/${id}`;

  const res = await axiosInstance.get(api);
  return res;
};

export const searchAreaUsageCustomers = (searchValues, pageValues) => {
  const api = APIEndpoint.SEARCH_AREAUSAGE_API;
  const payload = {
    requestObject: {
      yearOfBudget: searchValues.yearOfBudget || "",
      month: searchValues.month || "",
      lineOfWork: searchValues.lineOfWork || "",
      estateId: searchValues.estateId || "",
    },
    pageValue: {
      page: pageValues.page,
      pageSize: pageValues.pageSize,
      sortBy: pageValues.sortBy,
      sortDirection: pageValues.sortDirection,
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};

export const createAreaUsage = async (request) => {
  const api = APIEndpoint.CREATE_AREAUSAGE_API;
  const res = await axiosInstance.post(api, JSON.stringify(request));
  return res;
};

export const updateAreaUsage = async (id, request) => {
  const api = APIEndpoint.UPDATE_AREAUSAGE_API + `/${id}`;
  const res = await axiosInstance.put(api, JSON.stringify(request));
  return res;
};

export const deleteAreaUsage = (id) => {
  const api = APIEndpoint.DELETE_AREAUSAGE_API + `/${id}`;
  const res = axiosInstance.delete(api);
  return res;
};
